import classNames from "classnames";
import "./Asset.css";

function BaseImageAsset(src: string, alt?: string, extraClassName?: string) {
    return function ImageAsset(props: { className?: string }) {
        const { className } = props;
        return (
            <div className={classNames("web-lib__asset", extraClassName, className)}>
                <img src={src} alt={alt ?? undefined} />
            </div>
        );
    };
}

const Asset = {
    AlbertineEmblem: BaseImageAsset(
        "https://ik.imagekit.io/albertine/share/albertine-emblem.svg",
        "Albertine",
    ),
    AlbertineTextLogo: BaseImageAsset(
        "https://ik.imagekit.io/albertine/share/albertine-logo-text.svg",
        "Albertine",
    ),
    AlbertineLogo: BaseImageAsset(
        "https://ik.imagekit.io/albertine/share/albertine-logo.svg",
        "Albertine",
    ),
    PoweredByAlbertine: BaseImageAsset(
        "https://ik.imagekit.io/albertine/share/powered-by-albertine.svg",
        "Powered by Albertine",
    ),
    PoweredByAlbertineHBBrown: BaseImageAsset(
        "https://ik.imagekit.io/albertine/share/powered-by-albertine-hb-brown.svg",
        "Powered by Albertine",
    ),
    HBXPConciergeLogo: BaseImageAsset(
        "https://ik.imagekit.io/albertine/share/hb-xp-concierge-logo.svg",
        "Hugo Boss XP Concierge",
        "web-lib__asset-hb-logo",
    ),
    HBEmblem: BaseImageAsset(
        "https://ik.imagekit.io/albertine/share/hb-tenant-avatar.svg",
        "Hugo Boss XP Concierge",
    ),
    VisaI2Emblem: BaseImageAsset(
        "https://ik.imagekit.io/albertine/share/visa-i2-emblem.svg",
        "Infinite Private Concierge by Albertine",
    ),
    // TODO: This is the same as the HBEmblem, but it's a general image which is used for e.g. Mastercard too.
    // Maybe we should rename the file properly and use this image for both tenants.
    ConciergeBell: BaseImageAsset(
        "https://ik.imagekit.io/albertine/share/hb-tenant-avatar.svg",
        "Mastercard Digital Concierge",
    ),
};

export default Asset;
